import { IonLabel } from '@ionic/react'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ObjectContext } from '../../contexts/objectContext/ObjectContext'
import { trpc } from '../../modules/trpc'
import { peopleOptions } from './OnboardingTypeOptions'

interface Props {
	onInteraction: () => void
	onClick?: (value: number) => void
	state: [number, React.Dispatch<React.SetStateAction<number>>]
}

const PersonCountSlide: React.FC<Props> = ({ onInteraction, state, onClick }) => {
	const object = useContext(ObjectContext)
	if (!object) return null

	const { t, i18n } = useTranslation('pages_onboarding')

	const { mutate: updatePersonCount } = trpc.objects.edit.useMutation({
		onSuccess: () => {
			onInteraction()
		},
	})

	const handleOnClick = (value: number) => {
		if (onClick) {
			onClick(value)
			return
		}

		state[1](value)

		updatePersonCount({
			id: object.id,
			data: { personCount: value },
		})
	}

	return (
		<>
			<h1 className='text-text-dark dark:text-white'>{t('personCountSlide.montakoHenkiloa')}</h1>
			<div className='options-container'>
				{peopleOptions(i18n.language as 'fi' | 'en').map(option => (
					<div
						key={option.value}
						onClick={() => handleOnClick(option.value)}
						className={`option border border-brand-primary-100-light dark:border-brand-primary-100-dark${
							state[0] === option.value ? ' bg-brand-secondary-200-light dark:bg-surface-dark' : ''
						}`}
					>
						<IonLabel className='text-dark dark:text-text-grey-100'>{option.text}</IonLabel>
					</div>
				))}
			</div>
		</>
	)
}

export default PersonCountSlide
